import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/dmservices/api/v1'; // Default to your local API if not set

console.log("API Base URL:", API_BASE_URL);
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false, 
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Generic function to handle errors
const handleError = (error: any) => {
  console.error("API Error:", error.response ? error.response.data : error.message);
  throw error;
};

/**
 * 
 * @param followupStatus 
 * @param notes 
 * @param mobileNumber 
 * @returns 
 */
export const updateFollowupStatus = async (stage: string, followupStatus: string, notes: string, mobileNumber: string ) => {
    try {
      const response  = await apiClient.post("/user/update/Followup/Status", {stage, followupStatus, notes, mobileNumber});
      return response.data;
    } catch (e) {
      handleError(e)
    }
}

/**
 * 
 * @param assignTo 
 * @param notes 
 * @param followupStatus 
 * @param mobileNumber 
 * @returns 
 */
export async function updateAssignee(stage: string, assignTo: string, followupStatus: string, notes: string, mobileNumber: string) {
  const response = await apiClient.post("/user/update/assignee", {stage, assignTo, notes, followupStatus, mobileNumber});
  return response.data;
}

/**
 * 
 */
export async function fetchUsersByRole(role: string) {
  try {
    const response = await apiClient.get("/users/by-role", {  params: { role } });  
    return response.data;
  } catch (e) {
    handleError(e);
  } 
}

/**
 * 
 */
export const fetchUserList = async () => {
  try {
    const response = await apiClient.get(`/auth/user/list`);
    return response.data;
  } catch (err) {
    handleError(err);
  }
};

/**
 * 
 * @param month 
 * @param year 
 * @returns 
 */
export const fetchMonthlyLeadsReport = async (month: number, year: number) => {
  try {
    const response = await apiClient.get(`/reports/monthly-leads?month=` + year + '-' + month, {
      params: { month, year }
    });
    return response.data;
  } catch (e) {
    handleError(e);
  }
};

export const fetchMonthlyBusinessReport = async (month: number, year: number) => {
  try {
    const response = await apiClient.get(`/reports/monthly-business`, {
      params: { month, year }
    });
    return response.data;
  } catch (e) {
    handleError(e);
  }
};

export const fetchAnnualLeadsReport = async (year: number) => {
  try {
    const response = await apiClient.get(`/reports/annual-leads`, {
      params: { year }
    });
    return response.data;
  } catch (e) {
    handleError(e);
  }
};
